import React, { useEffect, useState } from 'react';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { useUser } from '../../lib/user';
import { IconButton } from '../Button';
import GImage from '../Image';
import Modal from '../Modals/Modal/Modal';

export default function MediaGallery({ onClose, message }) {
  const {
    state: { user },
  } = useUser();

  const [currentSlide, setCurrentSlide] = useState(1);

  const handleNextSlide = () => setCurrentSlide(currentSlide + 1);
  const handlePreviousSlide = () => setCurrentSlide(currentSlide - 1);

  useEffect(() => {
    const slide = document.getElementById(`mi-${currentSlide}`);
    if (currentSlide && slide) {
      slide.scrollIntoView({
        block: 'start',
        inline: 'nearest',
        behavior: 'smooth',
      });
    }
  }, [currentSlide]);

  return (
    <Modal isOpen onClose={onClose} transparent size="xl">
      <section
        className="media-gallery"
        role="presentation"
        onKeyPress={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <section className="gallery-items">
          {currentSlide > 1 && (
            <IconButton
              onClick={handlePreviousSlide}
              className="gallery-icon gallery-back"
              variant="light"
            >
              <FiArrowLeft className="w-6 h-6" />
              <span className="sr-only">Go back an image</span>
            </IconButton>
          )}
          {currentSlide < message.media.images.length && (
            <IconButton
              onClick={handleNextSlide}
              className="gallery-icon gallery-forward"
              variant="light"
            >
              <FiArrowRight className="w-6 h-6" />
              <span className="sr-only">Go forward an image</span>
            </IconButton>
          )}
          <section className="media">
            {message.media.images.map((image, i) => {
              return (
                <GalleryItem
                  key={image.src}
                  id={`mi-${i + 1}`}
                  src={image.src}
                  alt={`${user.name} gallery message media ${i + 1}${
                    message.message ? ` ${message.message}` : ''
                  }`}
                />
              );
            })}
          </section>
        </section>
      </section>
    </Modal>
  );
}

function GalleryItem({ id, alt, src }) {
  // const meta = getImageMetaFromUrl(src);
  return (
    <section id={id} className="gallery__item">
      <GImage
        src={src}
        alt={alt}
        // width={meta.width}
        // height={meta.height}
        // layout="responsive"
        className="gallery__image"
      />
    </section>
  );
}
